module.exports = __webpack_public_path__ + "media/images/icon/gray/ico_angle_left-8824598c078d6f100ccf5eccee6a5d2d.svg";